import axiosInstance from '../Config/AxiosInstance';

const PREFIX = `clinic/doctor/patient-roster`;
export const getPatient = (facilityId, searchString = '', providerId) => {
  let url = `${PREFIX}/patients?facilityId=${facilityId}&searchValue=${searchString}`;

  if (providerId !== undefined) {
    url += `&providerId=${providerId}`;
  }

  return axiosInstance.get(url);
};

export const addPatientToRoster = (
  dateTime,
  facilityId,
  patientIds,
  providerId
) => {
  const payload = {
    dateTime,
    facilityId,
    patientIds,
    providerId
  };

  return axiosInstance.post(PREFIX, payload);
};

export const getPatientRosterOfDoctor = (
  endDate,
  facilityId,
  startDate,
  providerId
) => {
  return axiosInstance.get(
    PREFIX +
      `?endDate=${endDate}&facilityIds=${facilityId}&startDate=${startDate}&providerId=${providerId}  `
  );
};
export const removePatientCard = rosterId => {
  return axiosInstance.delete(PREFIX + `?rosterId=${rosterId}`);
};
export const getBillerAuthor = facilityId => {
  return axiosInstance.get(PREFIX + `/biller/authors `);
};
export const getAuthorsUnderanAdmin = () => {
  return axiosInstance.get(PREFIX + `/admin/authors`);
};
export const getAccessData = () => {
  return axiosInstance.get(PREFIX + `/config/access`);
};
